import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../../../../ui/tooltip";

type DataType = "derived" | "estimated";

const labels: Record<DataType, { badge: string; tooltip: string }> = {
  derived: {
    badge: "Calculated",
    tooltip: "Calculated based on your actual review data",
  },
  estimated: {
    badge: "Estimated",
    tooltip: "Estimated impact based on industry benchmarks applied to your data",
  },
};

interface DataLabelProps {
  type: DataType;
  className?: string;
}

export const DataLabel = ({ type, className = "" }: DataLabelProps) => {
  const { badge, tooltip } = labels[type];
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`inline-flex items-center gap-1 text-[10px] text-muted-foreground cursor-help ${className}`}>
            <Info className="h-3 w-3" />
            {badge}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-[200px] text-xs">
          {tooltip}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export const NoData = ({ message = "No data available yet" }: { message?: string }) => (
  <p className="text-sm text-muted-foreground italic">{message}</p>
);
